module.exports = "/_next/static/images/airbnb-edit-organization-a35c8ca18906f007832bb3dee77f5a5f.jpg";